import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Auth0Provider from './auth0-provider';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { OrganizationProvider } from './context/organization';
import { initializeAnalytics } from './analytics';

import './index.css';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';

import 'leaflet/dist/leaflet.css';
import 'leaflet-draw/dist/leaflet.draw.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

initializeAnalytics();

root.render(
  <BrowserRouter>
    <Auth0Provider>
      <OrganizationProvider>
        <App />
        <ToastContainer />
      </OrganizationProvider>
    </Auth0Provider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
